export default function CTA() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
          Ready to Transform Your Property?
        </h2>
        <p className="text-xl text-gray-600 mb-10">
          Contact <strong>Burtman's Painting & Landscape</strong> today for your free estimate - no obligation
        </p>
        <button 
          onClick={scrollToContact}
          className="px-10 py-4 bg-gray-900 text-white text-base font-semibold rounded-full hover:bg-gray-800 transition-all inline-flex items-center space-x-2 cursor-pointer whitespace-nowrap shadow-lg"
        >
          <span>Schedule Consultation</span>
          <i className="ri-arrow-right-line text-xl"></i>
        </button>

        <div className="mt-16 flex items-center justify-center space-x-8 opacity-40">
          <div className="w-12 h-12 flex items-center justify-center">
            <i className="ri-brush-line text-4xl text-gray-900"></i>
          </div>
          <div className="w-12 h-12 flex items-center justify-center">
            <i className="ri-plant-line text-4xl text-gray-900"></i>
          </div>
          <div className="w-12 h-12 flex items-center justify-center">
            <i className="ri-tools-line text-4xl text-gray-900"></i>
          </div>
          <div className="w-12 h-12 flex items-center justify-center">
            <i className="ri-paint-brush-line text-4xl text-gray-900"></i>
          </div>
          <div className="w-12 h-12 flex items-center justify-center">
            <i className="ri-scissors-cut-line text-4xl text-gray-900"></i>
          </div>
        </div>
      </div>
    </section>
  );
}
